import React from "react";
import { useFormError } from "@magento/peregrine/lib/talons/FormError/useFormError";
import { GenericErrorModal } from "@Components/BookTable/GenericErrorModal";
const FormError = _ref => {
  let {
    classes: propClasses,
    errors,
    id,
    scrollOnError = true
  } = _ref;
  const talonProps = useFormError({
    errors
  });
  const {
    errorMessage
  } = talonProps;
  return errorMessage ? /*#__PURE__*/React.createElement(GenericErrorModal, {
    id: "form-error-".concat(id),
    isOpen: true,
    title: "ERROR",
    info: errorMessage
  }) : null;
};
export default FormError;